import React from "react";
import { faTriangleExclamation, faRotateRight, faHouse } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@components/ui";
import ErrorPageLayout from "./ErrorPageLayout";

export default function ErrorPage({ resetErrorBoundary }) {
    const handleReload = () => {
        if (resetErrorBoundary) {
            resetErrorBoundary();
        }
        if (typeof window !== "undefined") {
            window.location.reload();
        }
    };

    return (
        <ErrorPageLayout
            icon={faTriangleExclamation}
            variant="warning"
            headTitle="Villa kom upp"
            heading="Úps! Eitthvað fór úrskeiðis"
            message="Forritarar okkar hafa verið látnir vita og kíkja á málið. Reyndu að endurhlaða síðunni — yfirleitt lagast þetta við það."
            actions={
                <>
                    <Button text="Endurhlaða síðu" icon={faRotateRight} onClick={handleReload} />
                    <Button
                        text="Fara á forsíðu"
                        icon={faHouse}
                        inverted
                        onClick={() => {
                            if (typeof window !== "undefined") {
                                window.location.href = "/";
                            }
                        }}
                    />
                </>
            }
        />
    );
}
